import "src/stylesheets/jobs/top.scss"
import "src/javascripts/jobs/top.js"
